import { useMutation, useQuery } from "@tanstack/react-query";
import { message } from "antd";
import { AuthContextValue, useAuth } from "../../providers/AuthProvider";
import axiosBaseURL from "..";

export const useGetAgroDealersByOrderId = (id: string) => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["agro dealers by order id.", id],
    staleTime: 120,
    queryFn: async () => {
      if (!id) {
        return null;
      }
      const result = await axiosBaseURL.get(
        `/operation/agro-dealers?orderId=${id}`,
        {
          headers: {
            header: `${user?.userId}/${user?.token}`,
          },
        },
      );

      return result;
    },
  });
};

export const useGetAgroDealersList = () => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["all agro dealers"],
    staleTime: 120,
    queryFn: async () => {
      const result = await axiosBaseURL.get(`/operation/agro-dealer`, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
        },
      });

      return result;
    },
  });
};

export const useAssignOrderToAgroDealer = () => {
  const { user } = useAuth() as AuthContextValue;
  return useMutation({
    mutationFn: async (data: { orderId: number; orgId: number }) => {
      const result = await axiosBaseURL.post(
        `/off-taker/order/agro_dealer`,
        data,
        {
          headers: {
            header: `${user?.userId}/${user?.token}`,
          },
        },
      );

      return result;
    },
  });
};

export const useRemoveAgroDealerFromOrder = () => {
  const { user } = useAuth() as AuthContextValue;
  return useMutation({
    mutationFn: async (id: number) => {
      const result = await axiosBaseURL.put(
        `/off-taker/order/${id}/agro_dealer`,
        {},
        {
          headers: {
            header: `${user?.userId}/${user?.token}`,
          },
        },
      );

      return result;
    },
  });
};

export const useGetMyVouchers = () => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["my voucher"],
    staleTime: 12,
    queryFn: async () => {
      const result = await axiosBaseURL.get(`/ad/voucher`, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
        },
      });

      const _result = {
        status: "success",
        message: "message",
        length: result.data.length,
        data: result.data,
      };

      return _result;
    },
  });
};

export const useInputSales = () => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["useInputSales"],
    staleTime: 12,
    queryFn: async () => {
      const result = await axiosBaseURL.get(`/inputSales/list`, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
        },
      });

      return result;
    },
  });
};
